var sdk = require("./utils/sdk");
window.referlist = sdk;
module.exports = sdk;
